// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2ngIL","inner":"Form_inner__3WN5D","range":"Form_range__2MTPJ","name":"Form_name__a3eeu","actions":"Form_actions__1nwTs"};